module.exports = __webpack_public_path__ + "img/healthdata.a8886a28.png";